module.exports = __webpack_public_path__ + "static/media/eclassLogoFooter.0df80fdb.svg";